import { registerBlockType } from "@wordpress/blocks";
import config, { BlockAttributes } from "./block.json";
import ColumnSave from "./ColumnSave";
import ColumnEditor from "./ColumnEditor";

registerBlockType<BlockAttributes>(config.name, {
  ...config,

  edit: ColumnEditor,
  save: ColumnSave,
});
